import { createTheme } from "@mui/material/styles";

const baseMUIThemeConfig = {
  breakpoints: {
    values: {
      md: 1025,
      lg: 1331,
    },
  },
  typography: {
    fontFamily: '"Arial", sans-serif',
    button: {
      textTransform: "capitalize",
      fontWeight: "bold",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          padding: "10px 20px",
        },
      },
    },
  },
};

const MUIthemes = {
  bimstudio_theme: createTheme({
    ...baseMUIThemeConfig,
    palette: {
      primary: {
        main: "#ed6724",
        btn_background_color: "rgb(255, 118, 77)",
        btn_hover: "#f36c29",
        background_hover: "#f6b89b",
      }, // orange
      secondary: { main: "#000000bf" },
      // background: { default: "#f4f2ef", secondary: "#eae5df" },
      background: { default: "#ffffff", secondary: "#eae5df", third: "#f4f2ef" },
      title: { main: "#323232bf", secondary: "grey" },
    },
  }),

  mattamy_theme: createTheme({
    ...baseMUIThemeConfig,
    palette: {
      primary: {
        main: "#004282",
        btn_background_color: "#0b2c71",
        btn_hover: "#add8e6",
        background_hover: "#1030746e",
      },
      secondary: { main: "#0b2c71" },
      // background: { default: "#f4f2ef", secondary: "#eae5df" },
      background: { default: "#ffffff", secondary: "#eae5df", third: "#f4f2ef" },
      title: { main: "#004282", secondary: "grey" },
    },
  }),

  default: createTheme({
    ...baseMUIThemeConfig,
    palette: {
      primary: {
        main: "#2e2e2e",
        btn_hover: "#bfb6a8",
        background_hover: "#f8f6f0",
      },
      secondary: { main: "#6e6e6e" },
      // background: { default: "#f4f2ef", secondary: "#eae5df" },
      background: { default: "#ffffff", secondary: "#eae5df", third: "#f4f2ef" },
      title: { main: "#6e6e6e", secondary: "grey" },
    },
  }),
};

export const getMUIThemeByRole = (role) => {
  if (!role) return MUIthemes.default; // not logged in → homepage default theme
  if (role === "SALES" || role.startsWith("SALES_")) {
    return MUIthemes.mattamy_theme;
  } // logged in as "SALES" or "SALES_" → mattamy_theme
  return MUIthemes.bimstudio_theme; // everything else → bimstudio_theme
};

export const getCSSThemeByRole = (role) => {
  if (!role) return null;
  if (role === "SALES" || role.startsWith("SALES_")) {
    return "mattamy_theme";
  } // logged in as "SALES" or "SALES_" → mattamy_theme
  return "bimstudio_theme"; // everything else → bimstudio_theme
};
